import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {AuthPolicy, TopLevelDomain} from '@iana-rzms/bff-sdk';
import {ChangeVO} from '../../../generate/ChangeVO';

@Component({
    selector: 'lib-auth-policy',
    templateUrl: './auth-policy-screen.component.html',
    styleUrls: ['./auth-policy-screen.component.scss'],
    standalone: false
})
export class AuthPolicyScreenComponent implements  OnChanges  {

  @Input()
  domain: TopLevelDomain;

  @Input()
  pendingRequestChangeID: string;

  @Input()
  lastchange: string;

  @Input()
  authPolicyChange: ChangeVO;

  @Input()
  authPolicyUsersChange: ChangeVO;

  @Input()
  viewMode: boolean;

  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomain>();

  editMode: boolean;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  edit($event: boolean) {
    this.editMode = $event;
  }

  cancel($event: boolean) {
    this.edit(false);
  }

  authPolicyVOOutput(authPolicyVO: AuthPolicy) {
    this.domain.authPolicy = authPolicyVO;
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }
}
